export default __webpack_public_path__ + "static/media/basic-push-pin-11.b0a43ba2.png";